import React from 'react';
import { Truck } from 'lucide-react';

export const Logo = ({ size = 'medium', showText = true }) => {
  const sizes = {
    small: {
      container: 'w-8 h-8',
      icon: 'h-4 w-4',
      text: 'text-sm'
    },
    medium: {
      container: 'w-12 h-12',
      icon: 'h-6 w-6',
      text: 'text-base'
    },
    large: {
      container: 'w-16 h-16',
      icon: 'h-8 w-8',
      text: 'text-xl'
    }
  };

  const currentSize = sizes[size];

  return (
    <div className="flex items-center gap-3">
      <div className={`${currentSize.container} bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg flex items-center justify-center flex-shrink-0 relative overflow-hidden group`}>
        {/* Background pattern */}
        <div className="absolute inset-0 bg-gradient-to-tr from-blue-800/20 to-transparent"></div>
        
        {/* Truck icon */}
        <Truck className={`${currentSize.icon} text-white relative z-10 group-hover:scale-110 transition-transform duration-300`} />
        
        {/* Decorative lines */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-blue-500 opacity-50"></div>
      </div>
      
      {showText && (
        <div className="text-right">
          <h1 className={`${currentSize.text} font-bold text-gray-900 leading-tight`}>
            الميعاد الراسخ
          </h1>
          <p className="text-xs text-gray-600 hidden md:block">
            لاستيراد وسائل النقل وملحقاتها
          </p>
        </div>
      )}
    </div>
  );
};
